export const RESERVED_WORDS = [
  'and',
  'break',
  'continue',
  'do',
  'else',
  'elseif',
  'end',
  'export',
  'for',
  'if',
  'in',
  'local',
  'not',
  'or',
  'repeat',
  'return',
  'then',
  'until',
  'while',
];

export const LITERALS = ['false', 'nil', 'true'];

export const BUILT_INS = [
  '_G',
  '_VERSION',
  'assert',
  'collectgarbage',
  'error',
  'gcinfo',
  'getfenv',
  'getmetatable',
  'ipairs',
  'loadstring',
  'newproxy',
  'next',
  'pairs',
  'pcall',
  'print',
  'rawequal',
  'rawget',
  'rawlen',
  'rawset',
  'require',
  'self',
  'select',
  'setfenv',
  'setmetatable',
  'tonumber',
  'tostring',
  'type',
  'typeof',
  'unpack',
  'warn',
  'xpcall',
];

export const ROBLOX_BUILTINS = [
  'Enum',
  'PluginManager',
  'UserSettings',
  'elapsedTime',
  'game',
  'plugin',
  'script',
  'settings',
  'shared',
  'tick',
  'time',
  'version',
  'workspace',
];

export const LIBRARIES = {
  os: ['clock', 'date', 'difftime', 'time'],
  task: ['cancel', 'delay', 'defer', 'desynchronize', 'spawn', 'synchronize', 'wait'],
  coroutine: ['close', 'create', 'isyieldable', 'resume', 'running', 'status', 'wrap', 'yield'],
  debug: [
    'getmemorycategory',
    'info',
    'profilebegin',
    'profileend',
    'resetmemorycategory',
    'setmemorycategory',
    'traceback',
  ],
  math: [
    'abs',
    'acos',
    'asin',
    'atan',
    'atan2',
    'ceil',
    'clamp',
    'cos',
    'cosh',
    'deg',
    'exp',
    'floor',
    'fmod',
    'frexp',
    'huge',
    'ldexp',
    'log',
    'log10',
    'max',
    'min',
    'modf',
    'noise',
    'pi',
    'pow',
    'rad',
    'random',
    'randomseed',
    'round',
    'sign',
    'sin',
    'sinh',
    'sqrt',
    'tan',
    'tanh',
  ],
  table: [
    'clear',
    'clone',
    'concat',
    'create',
    'find',
    'foreach',
    'foreachi',
    'freeze',
    'getn',
    'insert',
    'isfrozen',
    'maxn',
    'move',
    'pack',
    'remove',
    'sort',
    'unpack',
  ],
  string: [
    'byte',
    'char',
    'find',
    'format',
    'gmatch',
    'gsub',
    'len',
    'lower',
    'match',
    'pack',
    'packsize',
    'rep',
    'reverse',
    'split',
    'sub',
    'unpack',
    'upper',
  ],
  bit32: [
    'arshift',
    'band',
    'bnot',
    'bor',
    'bxor',
    'btest',
    'byteswap',
    'countlz',
    'countrz',
    'extract',
    'lrotate',
    'lshift',
    'replace',
    'rrotate',
    'rshift',
  ],
  utf8: [
    'char',
    'charpattern',
    'codepoint',
    'codes',
    'graphemes',
    'len',
    'nfcnormalize',
    'nfdnormalize',
    'offset',
  ],
  buffer: [
    'copy',
    'create',
    'fill',
    'fromstring',
    'len',
    'readi16',
    'readi32',
    'readi8',
    'readf32',
    'readf64',
    'readstring',
    'readu16',
    'readu32',
    'readu8',
    'tostring',
    'writef32',
    'writef64',
    'writei16',
    'writei32',
    'writei8',
    'writestring',
    'writeu16',
    'writeu32',
    'writeu8',
  ],
};
